
import './Hinnakiri.css';
import {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import parse from 'html-react-parser'

import { Button, Navbar, Container, Nav, NavDropdown, Card, Row, Col, Image, Table, ThemeProvider } from 'react-bootstrap';
import HTMLReactParser from 'html-react-parser/lib/index';

function createContent() {
  try {
    return <h1>Failed to Load!</h1>
  }
  catch
   {
    return <h1>Failed to Load!</h1>
   }
}

export default function Hero() {
  const [fullcode, setFull] = useState()
 // const data = fetch("https://einblau.ee/backend/api/hinnakiri.php").then((r) => r.text());

  useEffect(() => {
    async function get(params) {
      const data = await fetch("https://einblau.ee/backend/api/hinnakiri.php").then((r) => r.text());
      if (data != null) {
      console.log("test " + data);
      var split = data.split("|")
      split.forEach(element => {
        var kons
        let error = false
        let th1 = document.createElement("th");
        let th2 = document.createElement("th");
        var t = element.split(";")
        console.log(t[0]);
        switch (t[0]) {
            //<tr><th style={{color: '#43ACE7', textAlign:"start"}}>{t[1]}</th><th style={{color:'#43ACE7', textAlign:"end"}}>{t[2]}</th></tr>
          case "Esmane konsultatsioon":
            kons = document.getElementById("konsultatsioon")
            break;
          case "Diagnoos ja plaan":
            kons = document.getElementById("diagnoos")
            break;
          case "Breketravi":
            kons = document.getElementById("breketravi")
            break
          case "Selged sirgendajad":
            kons = document.getElementById("sirgendajad")
            break
          case "Retentsioon":
            kons = document.getElementById("retentsioon")
            break
          case "Täiendavad protseduurid":
            kons = document.getElementById("täiendavad")
            break
          default:
            error = true;
            break
        }
        if (error == true) {
          
        } else
        {
          let tr = document.createElement("tr");
          tr.style.color = '#43ACE7'
          kons.appendChild(tr);    
          th1.innerText = t[1];
          th1.style.textAlign = "start"
          th2.innerText = t[2];
          th2.style.textAlign = "end"
                    th1.style.color = '#43ACE7'
          th2.style.color = '#43ACE7'
          tr.appendChild(th1);
          tr.appendChild(th2);
        }


        });
      }
        
    }
    get()

  }, [])

  return (<div>
        <Container>
          <h1 style={{marginBottom:"24px"}}></h1>
          <Container style={{justifyItems:"center"}}>
          <div className='table-holder'>
            <Table striped hover>
              <thead>
                <tr>
                  <th className='table-item1 table-header' style={{color:" #43ACE7"}}>Konsultatsioon </th>
                  <th className='table-item2 table-header' style={{color:" #43ACE7"}}>Hind</th>
                </tr>
              </thead>
              <thead id='konsultatsioon'>

              </thead>
            </Table>
          </div>

          <div className='table-holder'>
            <Table striped hover>
              <thead>
                <tr>
                  <th className='table-item1 table-header' style={{color:" #43ACE7"}}>Breketravi</th>
                  <th className='table-item2 table-header' style={{color:" #43ACE7"}}>Hind</th>
                </tr>
              </thead>
              <thead id='breketravi'>

              </thead>
            </Table>
          </div>
          <div className='table-holder'>
            <Table striped hover>
              <thead>
                <tr>
                  <th className='table-item1 table-header' style={{color:" #43ACE7"}}>Selged sirgendajad</th>
                  <th className='table-item2 table-header' style={{color:" #43ACE7"}}>Hind</th>
                </tr>
              </thead>
              <thead id='sirgendajad'>

              </thead>
            </Table>
          </div>
          <div className='table-holder'>
            <Table striped hover>
              <thead>
                <tr>
                  <th className='table-item1 table-header' style={{color:" #43ACE7"}}>Diagnoos ja plaan</th>
                  <th className='table-item2 table-header' style={{color:" #43ACE7"}}>Hind</th>
                </tr>
              </thead>
              <thead id='diagnoos'>

              </thead>
            </Table>
          </div>
          <div className='table-holder'>
            <Table striped hover>
              <thead>
                <tr>
                  <th className='table-item1 table-header' style={{color:" #43ACE7"}}>Retentsioon</th>
                  <th className='table-item2 table-header' style={{color:" #43ACE7"}}>Hind</th>
                </tr>
              </thead>
              <thead id='retentsioon'>

              </thead>
            </Table>
          </div>
          <div className='table-holder'>
            <Table striped hover>
              <thead>
                <tr>
                  <th className='table-item1 table-header' style={{color:" #43ACE7"}}>Täiendavad protseduurid</th>
                  <th className='table-item2 table-header' style={{color:" #43ACE7"}}>Hind</th>
                </tr>
              </thead>
              <thead id='täiendavad'>

              </thead>
            </Table>
          </div>
          </Container>
        </Container>
          </div>
          )
}